/**
 * Reserves the strip the note indicators are drawn in, and mirrors it on the left so the
 * text keeps even margins. `right` resolves against the padding box, so padding a text box
 * steps the text back, not the indicator.
 */

/** Set on the question area while annotations are available; scopes the reserve below. */
export const ANNOTATION_GUTTER_PROPS = {'data-annotation-gutter': ''} as const;

/**
 * Belongs on whichever box the annotatable text wraps in. Spelled out rather than
 * composed: Tailwind extracts candidates as static text, so interpolation emits none.
 */
export const ANNOTATION_GUTTER_CLASS = '[[data-annotation-gutter]_&]:px-x4';
